// extracted by mini-css-extract-plugin
export default {"hamburger-menu":"HamburgerMenuButton_hamburger-menu__q3tvT"};